interface IModalImage {
  Url: string
  Width: number
  Height: number
  AltIS: string
  AltEN: string
}

const parseImageString = (imageString) => {
  const imageObject = {} as IModalImage
  const properties = imageString.match(/(\w+)\s=\s([^\s,]+)/g)

  properties.forEach((prop) => {
    const [key, value] = prop.split(' = ')
    if (key === 'Width' || key === 'Height') {
      imageObject[key] = Math.round(parseFloat(value.replace(/['"]+/g, '')) * 1.7)
    } else {
      imageObject[key] = value.replace(/['"]+/g, '')
    }
  })

  if (imageObject.Url && imageObject.Width && imageObject.Height) {
    imageObject.Url = imageObject.Url.replace(/width=\d+/, `width=${imageObject.Width}`).replace(
      /height=\d+/,
      `height=${imageObject.Height}`
    )
  }

  return imageObject
}

const modalImage = {
  async render({ mobileString, desktopString, culture, arUrl }) {
    if (arUrl) {
      return `
        <div class="modal__picture">
          <img class="modal__image"
               src="${arUrl}"
               alt=""
               loading="lazy"
               decoding="async">
        </div>
      `
    }

    const mobile = mobileString ? parseImageString(mobileString) : null
    const desktop = desktopString ? parseImageString(desktopString) : null
    const breakpoint = 420

    let pictureContent = ''

    if (mobile) {
      const mobileHighDpiSrc = `${mobile.Url}?&format=webp`
      const mobileWidthHighDpi = mobile.Width * 2
      const mobileHeightHighDpi = mobile.Height * 2

      pictureContent += `
        <source media="(min-resolution: 120dpi) and (max-width: ${breakpoint}px)"
                srcset="${mobileHighDpiSrc}"
                width="${mobileWidthHighDpi}"
                height="${mobileHeightHighDpi}">
      `

      if (desktop) {
        const desktopHighDpiSrc = `${desktop.Url}?&format=webp`
        const desktopWidthHighDpi = desktop.Width * 2
        const desktopHeightHighDpi = desktop.Height * 2

        pictureContent += `
          <source media="(min-resolution: 120dpi) and (min-width: ${breakpoint + 1}px)"
                  srcset="${desktopHighDpiSrc}"
                  width="${desktopWidthHighDpi}"
                  height="${desktopHeightHighDpi}">

          <source media="(min-width: ${breakpoint}px)"
                  srcset="${desktop.Url}?&format=webp"
                  width="${desktop.Width}"
                  height="${desktop.Height}">
        `
      }

      const altText = culture === 'is' ? mobile.AltIS : mobile.AltEN
      pictureContent += `
        <img class="modal__image"
             src="${mobile.Url}?&format=webp"
             width="${mobile.Width}"
             height="${mobile.Height}"
             alt="${altText}"
             loading="lazy"
             decoding="async">
      `
    }

    return `
      <div class="modal__picture">
        <picture>
          ${pictureContent}
        </picture>
      </div>
    `
  },
}

export default modalImage
